import React, { FC } from 'react';

import { useLocaleConfig } from '../../../stores/LocaleConfigProvider';

interface CurrencyFormatProps {
  amount?: number;
  symbol?: string;
  className?: string;
  prefix?: string;
  suffix?: string;
}

const CurrencyFormat: FC<CurrencyFormatProps> = ({
  amount,
  className,
  prefix,
  suffix
}: CurrencyFormatProps) => {
  const localeConfig = useLocaleConfig();
  const amt = amount ?? 0;
  return (
    <span className={className}>
      {prefix ?? ''}
      {localeConfig?.formatCurrency(amt) ?? amt.toFixed(2)}
      {suffix ?? ''}
    </span>
  );
};

export default CurrencyFormat;
